import * as React from 'react'

import Svg, {
  Defs,
  LinearGradient,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

function SmartWatch(props) {
  return (
    <Svg
      width={37}
      height={37}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M22.4 7.7H9.6l.048-1.1.523-4.51c.05-.425.248-.816.559-1.1.31-.284.711-.44 1.126-.44h8.288c.415 0 .816.156 1.127.44.31.284.509.675.558 1.1l.523 4.51.048 1.1z"
        fill="url(#paint0_radial_1051_86879)"
      />
      <Path
        d="M22.4 25.3H9.6l.048 1.1.523 4.51c.05.425.248.816.559 1.1.31.284.711.44 1.126.44h8.288c.415 0 .816-.156 1.127-.44.31-.284.509-.675.558-1.1l.523-4.51.048-1.1z"
        fill="url(#paint1_radial_1051_86879)"
      />
      <Path
        d="M22.4 6.6H9.6c-1.767 0-3.2 1.477-3.2 3.3v13.2c0 1.822 1.433 3.3 3.2 3.3h12.8c1.767 0 3.2-1.477 3.2-3.3V9.9c0-1.823-1.433-3.3-3.2-3.3z"
        fill="url(#paint2_linear_1051_86879)"
      />
      <Path
        d="M16 17.05a.521.521 0 01-.421-.213l-3.733-4.95a.563.563 0 01.1-.762.522.522 0 01.741.086l3.443 4.565 2.262-1.399a.52.52 0 01.4-.056.535.535 0 01.323.25.565.565 0 01.062.41.55.55 0 01-.236.339l-2.667 1.65a.518.518 0 01-.274.08z"
        fill="#fff"
      />
      <Defs>
        <RadialGradient
          id="paint0_radial_1051_86879"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(141.432 8.262 3.67) scale(10.0873 11.1204)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1051_86879"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(141.432 3.932 16.045) scale(10.0873 11.1204)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <LinearGradient
          id="paint2_linear_1051_86879"
          x1={22.8052}
          y1={5.02952}
          x2={12.2865}
          y2={24.1928}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default SmartWatch
